module.exports = __webpack_public_path__ + "img/logo.be20b583.png";